import {I18n} from 'aws-amplify/utils';

import {PRODUCT_NAME} from './product';

/**
 * TRANSLATE A STRING, THEN PUT THE PRODUCT NAME IN IT.
 *
 * ⚠️ WHY NOT JUST INTERPOLATE INTO `I18n.get()` DIRECTLY.
 *
 * `I18n.get()` looks a translation up BY ITS ENGLISH TEXT — the string is the
 * key. Building that key with a template literal would make the lookup key
 * depend on a runtime value, so a rename would silently orphan every
 * translation of every affected string, and the dictionary would have to be
 * rewritten to match. Keeping `{product}` in the key keeps the key stable
 * whatever the product is called.
 *
 * So the order matters: translate first, substitute second.
 *
 *   productCopy('{product} will assume this role.')
 *     → I18n.get('{product} will assume this role.')   ← stable key
 *     → 'Flexi Domains will assume this role.'          ← what the customer reads
 *
 * ⚠️ THE APPLICATION IS "Flexi Domains", NOT "Flexi". Copy saying "Flexi will
 * assume this role" names neither the product nor the company, and a customer
 * whose AWS account will hold roles for Flexi Domains, Flexi Email and the
 * testing platform cannot tell which one is asking. That ambiguity is not
 * cosmetic when the sentence is about deleting their hosted zones.
 */
export function productCopy(key: string): string {
    return I18n.get(key).split('{product}').join(PRODUCT_NAME);
}
